const staffLanguages = [
    {
        value: 'fr',
        label: window.i18n.__("Français")
    },
    {
        value: 'en',
        label: window.i18n.__("English")
    }
]

export { staffLanguages };